import { TextField, MenuItem } from '@mui/material';
import { USTA_LEVELS } from '../../constants/userConstants';

interface USTALevelFieldProps {
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  disabled?: boolean;
  fullWidth?: boolean;
  helperText?: string;
  label?: string;
}

export default function USTALevelField({
  value,
  onChange,
  required = false,
  disabled = false,
  fullWidth = true,
  helperText,
  label = 'USTA Level',
}: USTALevelFieldProps) {
  return (
    <TextField
      fullWidth={fullWidth}
      select
      label={label}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      required={required}
      disabled={disabled}
      helperText={helperText}
    >
      <MenuItem value="">
        <em>Not specified</em>
      </MenuItem>
      {USTA_LEVELS.map((level) => (
        <MenuItem key={level} value={level}>
          {level}
        </MenuItem>
      ))}
    </TextField>
  );
}
